<template>
    <b-modal no-close-on-backdrop ref="teamModal" id="team-modal" title="Teams" hide-footer v-if="!showSelectedTeam">
        <f-create-team v-if="showFormCreateTeam" :key="teamId + updateKeyForm"/>
        <f-edit-team v-if="showFormEditTeam" :key="teamId + updateKeyForm"/>
        <f-create-project v-if="showFormCreateProject" :key="teamId"/>
        <f-edit-project v-if="showFormEditProject" :key="projectKey + updateKeyForm"/>
        <f-invite-user v-if="showFormInviteUser" :key="updateKeyForm"/>
        <f-change-team-owner v-if="showFormChangeTeamOwner" :key="updateKeyForm"/>
        <f-delete-team-user v-if="showFormDeleteTeamUser" :key="updateKeyForm"/>
        <f-project-token v-if="showProjectToken" :key="updateKeyForm"/>
    </b-modal>
    <b-modal  v-else no-close-on-backdrop ref="teamModal" id="team-modal" size="lg" title="Teams" hide-footer>
        <f-selected-team v-if="showSelectedTeam" :key="updateKeyForm"/>
    </b-modal>
</template>

<script>
const fCreateTeam = () => import('@/components/forms/f-create-team-form');
const fEditTeam = () => import('@/components/forms/f-edit-team-form');
const fCreateProject = () => import('@/components/forms/f-create-project-form');
const fEditProject = () => import('@/components/forms/f-edit-project-form');
const fInviteUser = () => import('@/components/forms/f-invite-user-form');
const fChangeTeamOwner = () => import('@/components/forms/f-change-team-owner-form');
const fDeleteTeamUser = () => import('@/components/forms/f-delete-team-user-form');
const fSelectedTeam = () => import('@/components/lists/details/f-selected-team');
const fProjectToken = () => import('@/components/lists/details/f-project-token');

export default {
    computed: {
        showFormEditTeam() {
            return this.$store.state.form.showFormEditTeam;
        },

        showFormChangeTeamOwner() {
            return this.$store.state.form.showFormChangeTeamOwner;
        },

        showFormDeleteTeamUser() {
            return this.$store.state.form.showFormDeleteTeamUser;
        },

        showProjectToken() {
            return this.$store.state.form.showProjectToken;
        },

        showFormCreateTeam() {
            return this.$store.state.form.showFormCreateTeam;
        },

        showFormEditProject() {
            return this.$store.state.form.showFormEditProject;
        },

        showFormCreateProject() {
            return this.$store.state.form.showFormCreateProject;
        },

        showFormInviteUser() {
            return this.$store.state.form.showFormInviteUser;
        },

        showSelectedTeam() {
            return this.$store.state.form.showSelectedTeam;
        },

        projectKey() {
            return this.$store.state.project.updateKey;
        },

        teamId() {
            return this.$store.state.team.current.id;
        },

        updateKeyForm() {
            return this.$store.state.team.updateKeyForm;
        },
    },

    components: {
        fCreateTeam,
        fEditTeam,
        fCreateProject,
        fEditProject,
        fInviteUser,
        fChangeTeamOwner,
        fDeleteTeamUser,
        fSelectedTeam,
        fProjectToken,
    }
}
</script>
